var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsSchwindel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 -1 23 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-schwindel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smiley-dizzy",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.5,
    cy: 11.5,
    r: 11.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 15,
    x2: 16,
    y2: 15,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,15 L12,18 C12,18.8284271 12.6715729,19.5 13.5,19.5 C14.3284271,19.5 15,18.8284271 15,18 L15,15",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,10.5 C5.11928813,10.5 4,9.38071187 4,8 C4,6.61928813 5.11928813,5.5 6.5,5.5 C7.6045695,5.5 8.5,6.3954305 8.5,7.5 C8.5,8.05228475 8.05228475,8.5 7.5,8.5 C6.94771525,8.5 6.5,8.05228475 6.5,7.5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,10.5 C15.1192881,10.5 14,9.38071187 14,8 C14,6.61928813 15.1192881,5.5 16.5,5.5 C17.6045695,5.5 18.5,6.3954305 18.5,7.5 C18.5,8.05228475 18.0522847,8.5 17.5,8.5 C16.9477153,8.5 16.5,8.05228475 16.5,7.5",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSchwindel);
export default __webpack_public_path__ + "static/media/icons-schwindel.d003e89a09b7e09c368ca02592b3c153.svg";
export { ForwardRef as ReactComponent };